import { useState, useEffect, useRef, useCallback } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  Typography,
  IconButton,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Autocomplete } from "@mui/lab";
import PublicWebsiteActions from "../../Actions/PublicWebsiteActions";
import PublicWebsiteConstants from "../../Constants/PublicWebsiteConstants";
import publicWebsiteStore from "../../Stores/PublicWebsiteStore";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import {
  useLanguageActionContext,
  useLanguageContext,
} from "../../Context/LanguageContext";
import { makeStyles } from "@mui/styles";
import {
  useEquipGrpPublicInfoActionsContext,
  useEquipGrpPublicInfoContext,
} from "../../Context/EquipGroupPublicInfoContext";
import { useLoggedInUserInfoContext } from "../../Context/LoggedInUserInfoContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      "& input": {
        fontSize: "16px",
      },
      "& .MuiSelect-select": {
        fontSize: "16px",
      },
      "& .MuiInputLabel-root": {
        fontSize: "16px",
      },
      "& .MuiInputBase-inputMultiline": {
        fontSize: "16px",
      },
    },
  },
}));

export default function FormTicketRaise({
  open,
  handleClose,
  anlageid,
  handleSubmitCallback,
}) {
  const fileInputRef = useRef();
  const classes = useStyles();
  const {
    register,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({ mode: "all" });
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const loggedInuserInfo = useLoggedInUserInfoContext();
  const { language, localization } = useLanguageContext();
  const UpdateLanguage = useLanguageActionContext();
  const equipGroupPublicWebConf = useEquipGrpPublicInfoContext();
  const getEquipmentGroupPublicInfo = useEquipGrpPublicInfoActionsContext();

  const [title, setTitle] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const [inputTitle, setInputTitle] = useState("");
  const [titleList, setTitleList] = useState([]);
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("Low");
  const [category, setCategory] = useState("");
  const [ticketFiles, setTicketFiles] = useState([]);
  const [scroll, setScroll] = useState("paper");
  const [categoryList, setCategoryList] = useState([]);

  const descriptionElementRef = useRef(null);

  useEffect(() => {
    if (anlageid) {
      if (
        equipGroupPublicWebConf.categories &&
        equipGroupPublicWebConf.categories != ""
      ) {
        setCategoryList(equipGroupPublicWebConf.categories);
      }
      getTitles(equipGroupPublicWebConf.anlagegruppeID);
    }
    return () => {};
  }, [anlageid]);

  useEffect(() => {
    UpdateLanguage(language);
    return () => {};
  }, [language]);

  const getTitles = (equipmentGroupId) => {
    PublicWebsiteActions.GetDistinctTitles(equipmentGroupId);
  };

  const getTitleDescription = () => {
    if (selectedTitle != null && selectedTitle != "") {
      PublicWebsiteActions.GetTitleDescription(
        equipGroupPublicWebConf.anlagegruppeID,
        selectedTitle,
      );
    } else {
      setDescription("");
    }
  };

  useEffect(() => {
    getTitleDescription();
    return () => {};
  }, [selectedTitle]);

  // Function to remove file by index
  const handleRemoveFile = (index) => {
    const updatedFiles = [...ticketFiles];
    updatedFiles.splice(index, 1);
    if (
      equipGroupPublicWebConf.isPhotoNeededForTicket &&
      updatedFiles.length == 0
    ) {
      fileInputRef.current.value = null;
      trigger("fileUpload");
    }
    setTicketFiles(updatedFiles);
  };

  const handleFormTicketRaise = () => {
    if (!equipGroupPublicWebConf) {
      toast.error(localization.equipmentDetailsAreMissing);
      return;
    }

    let data = {
      Id: null,
      TicketType: "EquipmentFault",
      Title:
        category && category !== ""
          ? category
          : inputTitle
            ? inputTitle
            : selectedTitle,
      Description: description,
      Language: language,
      TicketReferenceId: anlageid ? anlageid.toString() : "",
      Priority: priority,
      Category: category,
      Files: ticketFiles,
      Name: loggedInuserInfo.name,
      EmailAddresses: loggedInuserInfo.email,
      PhoneNumber: loggedInuserInfo.personalNr,
    };

    setGlobalSpinner(true);
    PublicWebsiteActions.CreateTicket(data);
  };

  const handleOnchange = (event) => {
    if (equipGroupPublicWebConf.isPhotoNeededForTicket) {
      trigger("fileUpload");
    }
    var files = Array.from(event.target.files);
    let tempFileArray = [...ticketFiles];
    if (files && files.length > 0) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          tempFileArray.push({
            Filename: file.name,
            Filecontent: reader.result,
            Filetyp: file.type,
            FileContentBytes: null,
          });
          setTicketFiles([...tempFileArray]);
        };
        reader.onerror = () => {};
        reader.readAsDataURL(file);
      });
    } else {
      setTicketFiles([]);
    }
  };
  const clearForm = () => {
    setSelectedTitle("");
    setInputTitle("");
    setTitle("");
    setDescription("");
    setPriority("Low");
    setCategory("");
    fileInputRef.current.value = null;
    setTicketFiles([]);
  };

  const validateFileInput = useCallback(() => {
    if (equipGroupPublicWebConf?.isPhotoNeededForTicket) {
      return ticketFiles.length == 0 ? false : true;
    }
    return true;
  }, [ticketFiles]);

  const updateDescription = (desc) => {
    setDescription(desc);
  };
  useEffect(() => {
    function createTicketSuccess() {
      var res = publicWebsiteStore.getCreateTicketResult();
      if (res) {
        toast.success(localization.ticketSuccess);
        clearForm();
        getEquipmentGroupPublicInfo(anlageid);
        handleSubmitCallback();
      }
      setGlobalSpinner(false);
    }

    function createTicketFailure() {
      var res = publicWebsiteStore.getCreateTicketResult();
      setGlobalSpinner(false);
      toast.error(res);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.CREATE_TICKET_SUCCESS,
      createTicketSuccess,
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.CREATE_TICKET_FAILURE,
      createTicketFailure,
    );

    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.CREATE_TICKET_SUCCESS,
        createTicketSuccess,
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.CREATE_TICKET_FAILURE,
        createTicketFailure,
      );
    };
  }, [localization]);

  useEffect(() => {
    function getTitleSuccess() {
      var res = publicWebsiteStore.getTitleResult();
      if (res != null && res != "" && res.length == undefined) {
        setTitleList([res.toString()]);
      } else if (res.length > 0) {
        setTitleList(res);
      }
      setGlobalSpinner(false);
    }

    function getTitleFailure() {
      var res = publicWebsiteStore.getTitleResult();
      setGlobalSpinner(false);
      toast.error(res);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_SUCCESS,
      getTitleSuccess,
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_FAILURE,
      getTitleFailure,
    );

    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_SUCCESS,
        getTitleSuccess,
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_FAILURE,
        getTitleFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getTitleDescriptionSuccess() {
      var res = publicWebsiteStore.getDescriptionResult();
      if (res) {
        updateDescription(res.description);
      }
      setGlobalSpinner(false);
    }

    function getTitleDescriptionFailure() {
      var res = publicWebsiteStore.getDescriptionResult();
      setGlobalSpinner(false);
      toast.error(res);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_DESCRIPTION_SUCCESS,
      getTitleDescriptionSuccess,
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_DESCRIPTION_FAILURE,
      getTitleDescriptionFailure,
    );
    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_DESCRIPTION_SUCCESS,
        getTitleDescriptionSuccess,
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_DESCRIPTION_FAILURE,
        getTitleDescriptionFailure,
      );
    };
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={scroll}
      maxWidth="sm"
      fullWidth
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        {localization.createNewTicket}

        <Typography
          variant="body2"
          color="textSecondary"
          className="mt-2 large-font "
        >
          {localization.submitNewTicket}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers={scroll === "paper"}>
        <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
          component="div"
        >
          <div className="ticketRaiseForm d-flex flex-direction-column gap-18">
            <form
              className={classes.root + " ticketRaiseForm w-100"}
              onSubmit={handleSubmit(handleFormTicketRaise)}
            >
              {/* ------------for category (now at the top) ------------ */}
              {categoryList && categoryList.length > 0 && (
                <div className="formStart m-0">
                  <label className="form-label">
                    {localization.ticketCategory}
                  </label>
                  <TextField
                    select
                    className="categorySelect   w-100 ml-0"
                    error={errors.category}
                    id="category"
                    fullWidth
                    value={category}
                    helperText={errors.category && errors.category?.message}
                    variant="outlined"
                    SelectProps={{
                      native: true,
                      displayEmpty: true,
                      renderValue: (selected) => {
                        if (!selected) {
                          return (
                            <span className="catergorySelectPlaceholder">
                              {localization.selectCategory}
                            </span>
                          );
                        }
                        return selected;
                      },
                    }}
                    InputLabelProps={{}}
                    // Category is now optional
                    {...register("category")}
                    InputProps={{
                      className: "  w-100",
                    }}
                    onChange={(e) => {
                      setCategory(e.target.value);
                    }}
                  >
                    <option value="">{localization.select}</option>
                    {categoryList.map((cat, index) => {
                      return (
                        <option key={index} value={cat}>
                          {cat}
                        </option>
                      );
                    })}
                  </TextField>
                </div>
              )}

              {/* title (hidden if category is selected) */}
              {(!category || category === "") && (
                <div className="formStart m-0 mt-1 ml-0">
                  <label className="form-label ">
                    {localization.ticketTitle}
                  </label>
                  <Autocomplete
                    freeSolo
                    id="title"
                    className="titleAutocomplete w-100 form-input "
                    value={selectedTitle}
                    inputValue={inputTitle}
                    options={titleList}
                    onChange={(e, newValue) => {
                      setSelectedTitle(newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setInputTitle(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={localization.enterSubject}
                        variant="outlined"
                        fullWidth
                        className=""
                        InputProps={{
                          ...params.InputProps,
                        }}
                        InputLabelProps={{}}
                        {...register("title", {
                          required: localization.titleRequired,
                          validate: (value) =>
                            value && value.trim() !== ""
                              ? true
                              : localization.titleRequired,
                        })}
                        error={Boolean(errors.title)}
                        helperText={errors.title?.message}
                      />
                    )}
                  />
                </div>
              )}

              {/* description */}
              <div className="fortmStar ml-0">
                <label className="form-label ">
                  {localization.description}
                </label>
                <TextField
                  placeholder={localization.describeTheIssueOrRequest}
                  className="ml-0"
                  error={errors.faultDescription}
                  id="faultDescription"
                  multiline
                  fullWidth
                  minRows={3}
                  value={description}
                  variant="outlined"
                  helperText={errors.faultDescription?.message}
                  InputLabelProps={{ className: "fs-18" }}
                  {...register("faultDescription", {
                    required: localization.descriptionRequired,
                  })}
                  InputProps={{ className: "ticketDescriptionArea" }}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                />
              </div>

              {/* ----------for priority ---------- */}
              <div className="formStart m-0">
                <label className="form-label">{localization.priority}</label>
                <TextField
                  select
                  className="prioritySelect  w-100 ml-0"
                  error={errors.priority}
                  id="priority"
                  fullWidth
                  value={priority}
                  helperText={errors.priority && errors.priority?.message}
                  variant="outlined"
                  SelectProps={{
                    native: true,
                  }}
                  InputLabelProps={{}}
                  {...register("Priority", {
                    required: localization.priorityRequired,
                  })}
                  InputProps={{
                    className: "  w-100",
                  }}
                  onChange={(e) => {
                    setPriority(e.target.value);
                  }}
                >
                  <option key="low" value="Low">
                    {localization.low}
                  </option>
                  <option key="medium" value="Medium">
                    {localization.medium}
                  </option>
                  <option key="high" value="High">
                    {localization.high}
                  </option>
                </TextField>
              </div>

              {/*---------------- For file to upload------------------ */}

              <div className="formStart m-0">
                <label className="form-label">{localization.attachments}</label>
                <div className="attachmentContainer">
                  {ticketFiles.length === 0 ? (
                    <Typography variant="body2" color="textSecondary">
                      {localization.noFilesSelected}
                    </Typography>
                  ) : (
                    <div>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        className="mb-8 fw-500"
                      >
                        {ticketFiles.length} {localization.filesSelected}
                      </Typography>
                      <ul className="list-none m-0 p-0 max-h-150px overflow-y-auto">
                        {ticketFiles.map((file, index) => (
                          <li
                            key={index}
                            className="d-flex align-items-center justify-content-between border-bottom-1 p-8"
                          >
                            <div className="d-flex align-items-center gap-8">
                              <span className=" mr-8px ">📄</span>
                              <Typography
                                variant="body2"
                                className="break-all max-w-200"
                              >
                                {file.Filename}
                              </Typography>
                            </div>
                            <Button
                              variant="text"
                              color="secondary"
                              size="small"
                              onClick={(e) => handleRemoveFile(index)}
                            >
                              <CloseIcon />
                            </Button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <Button
                    variant="outlined"
                    className="fileUploadButton"
                    onClick={() => fileInputRef.current.click()}
                    onBlur={() => fileInputRef.current.blur()}
                  >
                    {localization.selectFile}
                  </Button>
                </div>

                <TextField
                  className="faultImageFileInputCls"
                  error={errors.fileUpload}
                  inputRef={fileInputRef}
                  type="file"
                  id="fileUpload"
                  label={localization.chooseImage}
                  fullWidth
                  variant="outlined"
                  inputProps={{
                    multiple: true,
                    accept: "image/*",
                    capture: "environment",
                  }}
                  InputLabelProps={{}}
                  helperText={errors.fileUpload && errors.fileUpload?.message}
                  {...register("fileUpload", {
                    required:
                      equipGroupPublicWebConf?.isPhotoNeededForTicket &&
                      ticketFiles.length == 0
                        ? localization.imageIsRequired
                        : false,
                    validate: { validateFileInput },
                  })}
                  onChange={handleOnchange}
                />
              </div>
            </form>
          </div>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleSubmit(handleFormTicketRaise)}
          variant="contained"
          className="containedBtnCls"
          sx={{ textTransform: "none" }}
          size="large"
        >
          {localization.submit}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
